var parent = require('../../es/set');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/set/index.js
// module id = 610
// module chunks = 0 1